
import { Component, inject, Signal } from "@angular/core";
import { TranslocoPipe } from '@jsverse/transloco';
import { SkinningService } from '@core/skin';
import { PlayerService } from "../../data-access/player.service";
import { LiveTimelineService } from "../../data-access/live-timeline.service";
import { RoundedIconButton } from "app/shared/components/rounded-icon-button/rounded-icon-button";

@Component({
    selector: 'player-events',
    templateUrl: "./player-events.component.html",
    styleUrls: ['./player-events.component.scss'],
    imports: [
    TranslocoPipe,
    RoundedIconButton
]
})
export class PlayerEventsComponent {
    public skinning = inject(SkinningService);
    private playerService = inject(PlayerService);
    private liveTimeline = inject(LiveTimelineService);

    public isPlaying: Signal<boolean> = this.playerService.isPlaying;

    onPlayerClick() {
        if (this.playerService.isPlaying()) {
            // Same rule as the pause button and the keyboard: a live channel/programme (or the
            // customer) that forbids pausing is not paused by a click on the picture (AVIION-37638).
            if (!this.liveTimeline.isPauseEnabled()) return;
            this.playerService.pause().subscribe();
        } else {
            this.playerService.play().subscribe();
        }
    }
}
